import React,{useState} from "react";
import {
  Card,
  Table,
  Row,
  Col,
  Button
} from "react-bootstrap";
import "../../assets/css/table.css"
import constants from "../../constants";
import {ConfirmResendDepositModal} from "../Modals/ConfirmResendDepositModal"
import {resendCashplusOperation} from "../../services/OperationsService"
const toDateFormat = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleTimeString("fr-Fr", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });
};


var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'MAD',
});
const format = (price) => formatter.format(price)


function CashplusOperationsTable({operations, refresh}) {
  const [operation, setOperation] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleConfrimClick = async (id) => {
    handleCloseConfirmModal()
    let status = await resendCashplusOperation(id)
    if (status)
      refresh();
  }

  const handleCloseConfirmModal = () => setShowConfirmModal(false);
  if (!operations) {
    return null;
  }
  const resendOperation = (op) => {
    setOperation(op);
    setShowConfirmModal(true)
  }
  return (
    <>
        <ConfirmResendDepositModal
          show={showConfirmModal}
          handleClose={handleCloseConfirmModal}
          handleClick={handleConfrimClick}
          operation={operation}
        ></ConfirmResendDepositModal>
        <Row>
          <Col md="12">
            <Card className="card-plain table-plain-bg">
              <Card.Body className="table-full-width table-responsive px-0">
                <Table id="invoice">
                  <thead>
                    <tr>
                      <th className="border-0">Date</th>
                      <th className="border-0">Amount</th>
                      <th className="border-0">Token</th>
                      <th className="border-0">Destination</th>
                      <th className="border-0">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {operations.map((operation, index) => {
                      return (
                        <tr key={index}>
                          <td>{toDateFormat(operation.createdAt)}</td>
                          <td style={{color:'green'}}>{format(operation.amount)}</td>
                          <td>{operation.cpOperationToken}</td>
                          <td>{operation.phoneNumber}</td>
                          <td><Button onClick={() => resendOperation(operation)} variant="primary">Resend</Button>{' '}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
    </>
  );
}

export default CashplusOperationsTable;
